<template>
  <modal @before-open="beforeOpen" @before-close="beforeClose" @opened="opened" name="todo" :draggable="'.header'" :reset="true"
         :classes="['todobox','generalbox']"
         :adaptive="true"
         :height="'80%'" :width="'80%'" :max-width="1540" :max-height="885" :min-width="1092"
         :min-height="614" :click-to-close="false">
    <div v-if="isDetailMode || copyDetailStatus" @click="toOverview" class="back">
      <i class="iconfont icon-zuojiantou"></i>
    </div>

    <div @click="close" class="close">
      <i class="iconfont icon-cha"></i>
    </div>


    <div class="header">
      <h2>事项</h2>

    </div>
    <div v-if="copyDetailStatus" class="content">
      <copytoDetail :currentCopyto="currentCopyto" @detailSelectRow="openDetail"></copytoDetail>
    </div>
    <div v-if="!copyDetailStatus" class="content">
      <!--<button @click="openSchedule">打开日程详情</button>-->
      <div class="nav">
        <ul class="navlist">
            <li v-if="" @click="changeShowIndex(item.id)" v-for="item in navList" :class="{'on':item.id===selectTab}">
              {{item.title}}
            </li>
            <li v-if="isShowMyFinish" @click="changeShowIndex(myFinishTab.id)" :class="{'on':myFinishTab.id===selectTab}">
              {{myFinishTab.title}}
            </li>
          <li v-if="!isShowMyFinish" :class="{'on':todoTab.id===selectTab}" @click="changeShowIndex(todoTab.id)">抄送我的</li>
        </ul>

        <div style="display: none" @click="toggleCollectStatus" class="collect" :class="{'on':currentServiceSelected}">
          <i class="iconfont icon-shoucang"></i>
          收藏
        </div>
      </div>
      <div v-if="isDetailMode && selectTab !== 4" class="filter">
        <div class="inputArea">
          <div class="inputGroup">
            <label for="workName">标题：</label>
            <input v-model="workName" id="business" type="text">
          </div>
          <div v-if="false" class="inputGroup">
            <label for="appname">应用名称：</label>
            <multiselect v-model="appName"
                         :options="systemList"
                         :label="'name'"
                         placeholder="请选择应用名称"
                         :multiple="false"
                         :show-labels="false"
                         :clear-on-select="false"
                         :close-on-select="true"
                         :allow-empty="true"
                         :taggable="true"
            ></multiselect>

          </div>


          <div class="inputGroup dateGroup">
            <label for="pushTimeStart">{{getTimeRangetText}}：</label>
            <flatPickr v-model="startTime" :config="flatPickerConfig"></flatPickr>
            <span class="till">~</span>
            <flatPickr v-model="endTime" :config="flatPickerConfig"></flatPickr>
          </div>
          <div v-if="selectTab===0" class="inputGroup">
            <label for="appname">完成状态：</label>
            <multiselect v-model="selectSendState"
                         :options="sendState"
                         :label="'desc'"
                         placeholder="请选择完成状态"
                         :multiple="false"
                         :show-labels="false"
                         :clear-on-select="false"
                         :close-on-select="true"
                         :allow-empty="false"
                         :taggable="true"
            ></multiselect>

          </div>
          <div v-if="selectTab!==0" class="inputGroup">
            <label for="appname">申请人：</label>
            <input v-model="applyUser" type="text"/>

          </div>
        </div>
        <div class="btnGroup">
          <p class="desc">{{currFilterSysName}}：</p>
          <p v-if="selectTab===0" class="desc">
            我发出的事项
          </p>
          <p v-if="selectTab===1" class="desc">
            我收到的，待我处理的事项
          </p>
          <p v-if="selectTab===2" class="desc">
            我收到的，已经处理完的事项
          </p>

          <button @click="queryData" class="query">查询</button>
          <button @click="resetData" class="reset">重置</button>
          <button @click="exportTodoData" class="export">导出</button>
          <button @click="toOverview" class="reset">返回</button>

        </div>

      </div>
      <div v-if="!isDetailMode && selectTab !== 4" class="overvie">
        <div class="filterArea">
          <p class="desc">类别：</p>
          <multiselect v-model="selectTodoCate"
                       :options="getTodoCategory"
                       :label="'title'"
                       placeholder="请选择类别"
                       :multiple="false"
                       :show-labels="false"
                       :clear-on-select="false"
                       :close-on-select="true"
                       :allow-empty="true"
                       :taggable="true"
                       @select="sourceChange"
                       :allowEmpty="false"
          ></multiselect>
          <p class="desc">部门：</p>
          <multiselect v-model="selectTodoDept"
                       :options="getTodoDept"
                       :label="'title'"
                       placeholder="请选择部门"
                       :multiple="false"
                       :show-labels="false"
                       :clear-on-select="false"
                       :close-on-select="true"
                       :allow-empty="true"
                       :taggable="true"
                       @select="sourceChange"
                       :allowEmpty="false"
          ></multiselect>
          <p class="desc">来源：</p>
          <multiselect v-model="selectSource"
                       :options="sourceList"
                       :label="'dictLabel'"
                       placeholder="请选择来源"
                       :multiple="false"
                       :show-labels="false"
                       :clear-on-select="false"
                       :close-on-select="true"
                       :allow-empty="true"
                       :taggable="true"
                       @select="sourceChange"
                       :allowEmpty="false"
          ></multiselect>
          <div v-if="selectSource && selectSource.dictValue" class="searchContainer">
            <input @keypress.13="queryOverview" v-model="searchSysname" class="filterSysName" type="text"/>
            <button @click="queryOverview"><i class="iconfont icon-ai219"></i></button>
          </div>
          <button @click="resetOverview" class="resetBtn">重置</button>

        </div>
        <v-table
        ref="tableOverview"
        :row-click-color="'rgba(239,239,239,0.5)'"
        :row-click="overviewSelectRow"
        style="width:100%"
        :is-horizontal-resize="true"
        :columns="overviewColumns"
        :table-data="overviewData"
        :show-vertical-border="false"
        ></v-table>
      </div>
      <div v-if="!isDetailMode && selectTab === 4"  class="todolist" style="margin-top: 20px">
        <v-table
        :row-click-color="'rgba(239,239,239,0.5)'"
        :row-click="copySelectRow"
        style="width:100%"
        :is-horizontal-resize="true"
        :columns="copyColumns"
        :table-data="copyData"
        :show-vertical-border="false"
        ></v-table>
      </div>
      <div v-if="isDetailMode && selectTab !== 4" class="todolist">
        <v-table
        :row-click-color="'rgba(239,239,239,0.5)'"
        :row-click="selectRow"
        style="width:100%"
        :is-horizontal-resize="true"
        :columns="columns"
        :table-data="tableData"
        :show-vertical-border="false"
        ></v-table>
        <div class="pagination">
          <v-pagination @page-change="pageChange" @page-size-change="pageSizeChange" :total="detailPage.totalCount"
                        :pageIndex="detailPage.pageNumber" :page-size="detailPage.pageSize"></v-pagination>
        </div>

      </div>

    </div>
  </modal>
</template>

<script>

  // const ROWS_PRE_PAGE=10;
  // const SEARCH_PROP="workTitle";

  import axios from 'axios';
  import multiselect from 'vue-multiselect';
  import flatPickr from 'vue-flatpickr-component';
  import {Mandarin} from 'flatpickr/dist/l10n/zh.js';
  import apiConfig from 'common/js/api_config'
  import copytoDetail from 'components/todo/copytoDetail'
  //vuex
  import {mapState, mapGetters, mapMutations} from 'vuex';
  //通信总线
  import Bus from 'common/js/bus.js';

  export default {
    name: "todo",
    data() {
      return {
        currentCopyto: null,
        copyDetailStatus: false,
        copyData: [],
        //选择器配置
        flatPickerConfig: {
          enableTime: false,
          dateFormat: "Y-m-d",
          locale: Mandarin,
        },
        //当前选中的选项卡
        selectTab: 0,

        //视图模式：0:overview 1:detail
        isDetailMode: 0,

        //********筛选数据********

        workName: null,      //任务名称
        appName: null,       //应用名称
        startTime: null, //送达开始时间
        endTime: null,   //送达结束时间

        //*******分页相关***********
        detailPage: {
          pageSize: 10,
          pageNumber: 1,
          pageCount: null,
          totalCount: 0,
        },
        //tab列表
        navList: [
          {
            title: "我发出的",
            isShow: true,
            id: 0
          },
          {
            title: "我收到的",
            isShow: true,
            id: 1
          },
        ],
        myFinishTab: {
          title: "我的已办",
          id: 2
        },
        todoTab: {
          title: '我的抄送',
          id: 4
        },
        tableData: [],
        overviewData: [],


        //当前选择的项
        currentServiceSelected: false,
        //事务选项
        selectOptions: ["教务", "学工", "OA"],
        //来源列表
        sourceList: [],
        //当前选择的来源
        selectSource: null,
        //当前搜索的系统名
        searchSysname: null,
        //申请人(我收到的)
        applyUser: null,
        //状态(我发出的)
        sendState: [
          {
            desc: '全部',
            value: -1
          },
          {
            desc: '进行中',
            value: 0
          },
          {
            desc: '已完结',
            value: 1
          }
        ],
        selectSendState: {
          desc: '全部',
          value: -1
        },
        //当前展示的系统
        currFilterSysName: null,

        //----------系统筛选----------
        selectTodoCate: null,
        selectTodoDept: null,

        //-----是否执行过一次筛选-----
        isRunOnceFilter: false,
        sysid: ''
      }
    },
    methods: {
      ...mapMutations(['updateModalZIndex']),
      close() {
        this.$modal.hide("todo");
      },
      openSchedule() {
        this.$modal.show("schedule");
      },
      changeShowIndex(id) {
        console.log(id)
        this.selectTab = id;

        if (id === 4) {
          console.log('点击了抄送')
        }
        if (!this.isDetailMode) {
          this.$nextTick(() => {
            this.$refs.tableOverview.tableResize()
          })
          this.queryOverview();
        } else {
          this.queryData();
        }


      },
      toggleCollectStatus() {
        this.currentServiceSelected = !this.currentServiceSelected;
      },
      //详情选择行
      selectRow(rowIndex, rowData, column) {
        if (column.field === "title") {
          console.log(rowIndex, rowData, column)
          if (rowData.url) {
            //如果标记为新窗口打开
            if (rowData.appOpenType === 'window') {
              window.open(rowData.url)
              return
            }
            this.openDetail({title: rowData.title, url: rowData.url})
          } else {
            this.$notify({
              group: "global",
              title: "温馨提示",
              text: rowData.title + "<br/><br/>状态：" + this.getStateText(rowData)
            })
          }
        }
      },
      // 抄送选择行
      copySelectRow (rowIndex, rowData, column) {
        this.currentCopyto = rowData
        this.copyDetailStatus = true
      },
      //总览选择行
        overviewSelectRow(rowIndex, rowData, column) {
        if (column.field === "receiveRunningnum") {
          console.log(rowIndex, rowData, column)
        }
        switch (column.field) {
          case "sysname":
            this.selectSendState = {
              desc: '全部',
              value: -1
            }
            this.filterDetailData(rowData.sysname,rowData.sysid);
            break;
          case "sendRunningNum":
            this.selectSendState = {
              desc: '进行中',
              value: 0
            }
            this.filterDetailData(rowData.sysname,rowData.sysid);
            break;
          case "sendDonenum":
            this.selectSendState = {
              desc: '已完结',
              value: 1
            }
            this.filterDetailData(rowData.sysname,rowData.sysid);
            break;
          case "receiveRunningnum":
            this.selectSendState = {
              desc: '已完结',
              value: 1
            }
            this.filterDetailData(rowData.sysname,rowData.sysid);
            break;
          case "receiveDonenum":
            this.selectTab = 2;
            this.filterDetailData(rowData.sysname,rowData.sysid);
            break;

          default:
            console.log('overviewSelectRow field:参数异常')
        }
      },
      //获取日期字符串
      getDateString(d) {
        if (!d) {
          return null;
        }
        return d.toLocaleDateString().replace(/\//g, "-");
      },

      //*****[overview分页回调]******
      overviewPageChange(pageIndex) {
        this.overviewPage.pageNumber = pageIndex;
        this.queryOverview();
      },
      overviewPageSizeChange(newPageSize) {
        this.overviewPage.pageSize = newPageSize;
        this.queryOverview();
      },
      //*****[detail分页回调]******
      pageChange(pageIndex) {
        this.detailPage.pageNumber = pageIndex;
        this.queryData();
      },
      pageSizeChange(newPageSize) {
        this.detailPage.pageNumber = 1;
        this.detailPage.pageSize = newPageSize;
        this.queryData();
      },

      //*****查询详情******
      async queryData() {

        let queryParams = {
          sysname: this.appName,
          sysid: this.sysid,
          type: this.selectTab,
          pageSize: this.detailPage.pageSize,
          pageNumber: this.detailPage.pageNumber,
          title: this.workName,
          starttime: this.startTime, //任务创建时间，可为空，起始，格式：2018-12-17
          endtime: this.endTime,   //任务创建时间，可为空，结束，格式：2018-12-17
        }

        if (!this.selectTab) {
          queryParams.state = this.selectSendState ? this.selectSendState.value : ''
        } else {
          queryParams.username = this.applyUser
        }

        let newData = await axios.post(apiConfig.REQUEST_URL + '/shall/front_getWorkList?' + this.$qs.stringify({
          sysname: queryParams.sysname,
          sysid: queryParams.sysid,
          type: queryParams.type,
          pageSize: queryParams.pageSize,
          pageNumber: queryParams.pageNumber,
          title: queryParams.title,
          starttime: queryParams.starttime,
          endtime: queryParams.endtime
        }));
        newData = newData.data.data[0];
        console.log(newData);

        this.detailPage.totalCount = newData.totalCount;
        this.detailPage.pageNumber = newData.pageNumber;
        this.tableData = newData.list;
        this.autoEnterTheOneItem()
      },
      //只有一条数据时自动进入详情
      autoEnterTheOneItem() {
        if (this.isRunOnceFilter) {
          return
        }
        this.isRunOnceFilter = true
        if (!this.tableData.length) {
          this.close()
          this.$notify({
            group: 'global',
            title: '温馨提示',
            text: '暂无条目！'
          })
          return
        }
        if (this.tableData.length === 1) {
          let newDataItem = this.tableData[0]
          if (newDataItem.appOpenType === 'window') {
            window.open(newDataItem.url)
          } else {
            this.openDetail({title: newDataItem.title, url: newDataItem.url})
          }
        }
      },
      //*****查询总览******
      async queryOverview() {
        let newData = await axios.post(apiConfig.REQUEST_URL + "/shall/front_getWorkCount?" + this.$qs.stringify({
          state: this.selectTab,
          from: this.selectSource ? this.selectSource.dictValue : '',
          sort: 1,
          sysname: (this.selectSource && this.selectSource.dictValue) ? (this.searchSysname ? this.searchSysname : '') : null,
          deptid: this.selectTodoDept ? this.selectTodoDept.value : -1,
          typeid: this.selectTodoCate ? this.selectTodoCate.value : -1
        }));
        newData = newData.data.data[0];
        if (newData.list) {
          this.overviewData = newData.list;
          this.isRunOnceFilter = true
        }

      },

      //筛选详情数据
      filterDetailData(sysname, sysid, startTime, endTime) {
        this.isDetailMode = 1;
        this.currFilterSysName = sysname;
        console.log(`筛选条件：`, sysname, startTime, endTime);
        this.appName = sysname ? sysname : null;
        this.sysid = sysid
        this.startTime = startTime ? startTime : null;
        this.endTime = endTime ? endTime : null;
        this.queryData();
      },

      resetData() {
        //********筛选数据********

        this.workName = null;     //任务名称
        //this.appName = null;     //应用名称
        this.startTime = null; //送达开始时间
        this.endTime = null; //送达结束时间

        //*******分页相关******
        this.pageSize = 10;
        this.pageNumber = 1;
        this.pageCount = null;
        this.totalCount = 0;
        this.queryData();
      },

      //返回总览视图
      toOverview() {
        if (this.selectTab === 2) {
          this.selectTab = 1
        }
        this.copyDetailStatus = false
        this.isDetailMode = 0;

        this.$nextTick(() => {
          this.queryOverview()
        })
      },
      //生成表格高亮标签
      getLinkedText(rowData, rowIndex, pagingIndex, field) {
        return `<span class="highlightLink">${rowData[field]}</span>`;
      },
      //完成状态处理： 1 未启动 2 进行中 3 挂起 7 完成 8 终止
      getStateText_back(rowData, rowIndex, pagingIndex, field) {
        let state = rowData.state;
        let stateText = "";
        switch (state) {
          case 1:
            stateText = "未启动";
            break;
          case 2:
            stateText = "进行中";
            break;
          case 3:
            stateText = "挂起";
            break;
          case 7:
            stateText = "完成";
            break;
          case 8:
            stateText = "终止";
            break;
          default:
            console.log("getStateText参数异常", state)

        }
        return stateText;
      },

      //【新】完成状态处理： 1 未启动 2 进行中 3 挂起 7 完成 8 终止
      getStateText(rowData, rowIndex, pagingIndex, field) {

        let state = rowData.state;
        let stateText = "";

        if (this.selectTab === 1) {
          //我收到的【没办完的】
          switch (state) {
            case 4:
              stateText = "待处理";
              break;
            case 8:
              stateText = "待处理";
              break;
            case 10:
              stateText = "待处理";
              break;
            case 12:
              stateText = "已处理";
              break;
            case 13:
              stateText = "终止";
              break;
            case 0:
              stateText = "进行中";
              break;
            case 1:
              stateText = "已完成";
              break;
            default:
              stateText = "异常" + state;
              console.log("getStateText参数异常", state)
          }
        } else if (this.selectTab === 2) {
          //我收到的【办完的】
          switch (state) {
            case 4:
              stateText = "进行中";
              break;
            case 8:
              stateText = "挂起";
              break;
            case 10:
              stateText = "进行中";
              break;
            case 12:
              stateText = "已完结";
              break;
            case 13:
              stateText = "退回";
              break;
            case 0:
              stateText = "进行中";
              break;
            case 1:
              stateText = "已完成";
              break;
            default:
              stateText = "异常" + state;
              console.log("getStateText参数异常", state)
          }
        } else if (this.selectTab === 0) {
          //我发出的
          switch (state) {
            case 2:
              stateText = "进行中";
              break;
            case 3:
              stateText = "挂起";
              break;
            case 7:
              stateText = "已完结";
              break;
            case 8:
              stateText = "终止";
              break;
            case 0:
              stateText = "进行中";
              break;
            case 1:
              stateText = "已完成";
              break;

            default:
              stateText = "异常" + state;
              console.log("getStateText参数异常", state)
          }
        }

        return stateText;
      },

      //打开前钩子
      async beforeOpen(data) {
        console.log(data.params,'8555555555555555555555')
        /**
         * overview:进入统计
         * type:直接进入详情
         */
        this.isRunOnceFilter = false
        this.initParamDeal(data.params)
        this.refreshList();
        this.getCopyto()

        //外部打开详细列表
        if (data.params.fromService) {
          this.filterDetailData(data.params.fromService,data.params.sysid)
        }
        let sourceList = await axios.post(apiConfig.REQUEST_URL + '/shall/front_getDictEntry?' + this.$qs.stringify({
          title: 'FROM_SYSTEM',
          type: 1
        }))
        this.sourceList = sourceList.data.data

      },
      async beforeClose () {
        this.copyDetailStatus = false
      },
      //初始化参数处理
      initParamDeal(params) {
        console.log(params);
        //打开总览
        if (params.overview || params.overview === 0) {
          this.selectTab = params.overview
          this.isDetailMode = 0
          return
        }

        //筛选：我发出的状态
        switch (params.sendState) {
          case 0:
            this.selectSendState = {
              desc: '进行中',
              value: 0
            }
            break;
          case 1:
            this.selectSendState = {
              desc: '已完结',
              value: 1
            }
            break;
          default:
            this.selectSendState = {
              desc: '全部',
              value: -1
            }
        }

        //打开详情f
        switch (params.type) {
          case 0:
            //rubbish flow
            this.selectTab = 0;
            this.isDetailMode = 0;
            break;
          case 1:
            this.selectTab = 1;
            this.filterDetailData(params.data.sysname,params.data.sysid)
            break;
          case 2:
            this.selectTab = 0;
            this.filterDetailData(params.data.sysname,params.data.sysid)
            break;
          case 3:
            this.selectTab = 2;
            this.filterDetailData(params.data.sysname,params.data.sysid)
            break;
          case 4:
            console.log('展示我抄送的详情')
            this.currentCopyto = params.data
            this.selectTab = 4
            this.copyDetailStatus =  true
          default:
            console.log("todo beforeopen type参数异常")
        }

        //我发出的状态
        // setTimeout(()=>{
        //   //TODO:...
        //   this.queryData()
        // },1000)


      },

      //打开外部页面
      openDetail(data) {
        let url = data.url;
        let title = data.title;
        this.$modal.show("extraPage", {url, title, stackLayout: true});
      },
      //刷新列表
      refreshList() {
        if (this.isDetailMode) {
          this.queryData();
        } else {
          this.queryOverview();
        }
      },
      //选择来源
      sourceChange() {
        this.$nextTick(() => {
          this.queryOverview()
        })

      },
      opened() {
        this.updateModalZIndex(this.$el)
      },
      resetOverview() {
        this.selectTodoCate = null
        this.selectTodoDept = null
        this.selectSource = null
        this.searchSysname = null
        this.queryOverview()
      },
      async exportTodoData() {
        let paramStr = this.$qs.stringify({
          sysname: this.appName,
          type: this.selectTab === 2 ? 1 : this.selectTab
        })
        let resp = await axios.post(apiConfig.REQUEST_URL + '/shall/front_getWorkDataExportUrl?' + paramStr)
        if (resp.data.status) {
          let urlObj = JSON.parse(resp.data.data[0])
          window.open(urlObj.msg)
        }
      },
      async getCopyto () {
        let copyData = await axios.post(apiConfig.REQUEST_URL + "/shall/front_getCarbonCopyMsgTotalForUser")
        this.copyData = copyData.data.data[0];
      }
    },
    computed: {
      ...mapGetters(['getTodoCategory', 'getTodoDept']),
      ...mapState(['systemList']),
      getTimeRangetText() {
        let text = "";
        switch (this.selectTab) {
          case 0:
            text = "创建时间";
            break;
          case 1:
            text = "到达时间";
            break;
          case 2:
            text = "处理时间";
            break;
          default:
            console.log("getTimeRangetText异常");
        }
        return text;
      },
      getOverviewDynamicColumn() {
        let arr = [];
        let pushToArr = (field, title) => {
          arr.push({
            field: field,
            title: title,
            width: 100,
            titleAlign: 'center',
            columnAlign: 'center',
            isResize: true,
            formatter: this.getLinkedText
          });
        };
        switch (this.selectTab) {
          case 0:
            pushToArr('sendRunningNum', '进行中');
            pushToArr('sendDonenum', '已完结');
            // pushToArr('time', '最近更新时间');
            // pushToArr('sendRunningNum','待办');
            break;
          case 1:
            pushToArr('receiveRunningnum', '待处理');
            pushToArr('receiveDonenum', '已处理');
            // pushToArr('time', '最近更新时间');
            break;
          case 2:
            pushToArr('receiveDonenum', '我完成的');
            // pushToArr('time', '最近更新时间');
            break;
          default:
            console.log("getOverviewDynamicColumn参数异常");

        }

        return arr;
      },
      getDynamicColumn() {
        let arr = [];
        let pushToArr = (field, title) => {
          arr.push({
            field: field,
            title: title,
            width: 100,
            titleAlign: 'center',
            columnAlign: 'center',
            isResize: true,
          });
        };
        switch (this.selectTab) {
          case 0:
            // pushToArr('username', '处理人');
            pushToArr('starttime', '上次处理时间');
            break;
          case 1:
            pushToArr('username', '申请人');
            break;
          case 2:
            pushToArr('username', '申请人');
            break;
          default:
            console.log("getOverviewDynamicColumn参数异常");

        }

        return arr;
      },

      overviewColumns() {
        return [
          {
            field: 'custome', title: '序号', width: 150, titleAlign: 'center', columnAlign: 'center',
            formatter: function (rowData, rowIndex, pagingIndex, field) {
              return rowIndex + 1;
            }, isFrozen: true, isResize: false
          },
          {
            field: 'sysname',
            title: '事项',
            width: 100,
            titleAlign: 'center',
            columnAlign: 'center',
            isResize: true,
            formatter: this.getLinkedText
          },
          ...this.getOverviewDynamicColumn,
          // {field: 'time', title: '最近更新时间', width: 100, titleAlign: 'center', columnAlign: 'center', isResize: true},
          {field: 'from', title: '来自', width: 100, titleAlign: 'center', columnAlign: 'center', isResize: true},
        ]
      },
      copyColumns () {
        return [
          {
            field: 'custome', title: '序号', width: 150, titleAlign: 'center', columnAlign: 'center',
            formatter: function (rowData, rowIndex, pagingIndex, field) {
              return rowIndex + 1;
            }, isFrozen: true, isResize: false
          },
          {
            field: 'processChName',
            title: '事项',
            width: 100,
            titleAlign: 'center',
            columnAlign: 'center',
            isResize: true,
            formatter: this.getLinkedText
          },
          {
            field: 'num',
            title: '条数',
            width: 100,
            titleAlign: 'center',
            columnAlign: 'center',
            isResize: true,
          }
        ]
      },
      //详情数据字段
      columns() {
        return [
          // {field: 'checkbox', title: '复选', width: 100, titleAlign: 'center', columnAlign: 'center', isResize: false,type: 'selection'},
          {
            field: 'custome', title: '序号', width: 150, titleAlign: 'center', columnAlign: 'center', isResize: false,
            formatter: (rowData, rowIndex, pagingIndex, field) => {
              return (this.detailPage.pageSize * (this.detailPage.pageNumber - 1)) + rowIndex + 1;
            }, isFrozen: true
          },
          {
            field: 'title',
            title: '标题',
            width: 100,
            titleAlign: 'center',
            columnAlign: 'center',
            isResize: true,
            formatter: this.getLinkedText
          },
          {
            field: 'orgname',
            title: '发起部门',
            width: 100,
            titleAlign: 'center',
            columnAlign: 'center',
            isResize: true,
          },
          ...this.getDynamicColumn,
          // {field: 'username', title: '申请人', width: 100, titleAlign: 'center', columnAlign: 'center', isResize: true},
          {field: 'applytime', title: '创建时间', width: 100, titleAlign: 'center', columnAlign: 'center', isResize: true},
          {
            field: 'arriveTime',
            title: '完成状态',
            width: 100,
            titleAlign: 'center',
            columnAlign: 'center',
            isResize: true,
            formatter: this.getStateText
          }
        ]
      },
      isShowMyFinish() {
        if (this.isDetailMode) {
          return true;
        }
        return false;
      }
    },
    mounted() {
      Bus.$on("todoHandleFinish", () => {
        this.refreshList();
      })
    },
    components: {multiselect, flatPickr, copytoDetail}
  }
</script>

<style lang="stylus" scoped>
  .back
    position absolute
    width 30px
    height 30px
    border none
    right 70px
    top 10px
    z-index 99
    border-radius 50%
    text-align center
    line-height 30px
    color #b8b8b8
    background-color #efefef
    transition 300ms
    cursor pointer
    font-size 15px

  .content
    .filter
      margin 20px
      padding 10px
      box-shadow 2px 2px 3px #cccccc

      .inputArea
        white-space nowrap
        border-bottom 1px solid #eeeeee
        margin-bottom 10px

        &::after
          content ""
          width 100%
          display block
          clear both

        .inputGroup
          display inline-block
          float left
          margin-left 20px
          /*width 33.33%*/
          margin-bottom 10px
          line-height 30px
          text-align left

          .till
            margin 0 2px

          label
            font-size 12px
            color #666666
            display inline-block
            width 60px
            height 40px
            line-height 35px
            text-align right

            &::after
              content ""
              display block
              height 0
              width 100%

          & >>> input
            width 260px
            height 26px
            font-size 12px
            color #666666
            border-radius 13px
            padding 0 0.5em
            border 1px solid #cccccc
            vertical-align middle
            transition 300ms

            &:focus
              border-color #0077ee

        .dateGroup
          /*width 66.66%*/

          & >>> input
            text-align center
            width 260px

          & >>> div
            display inline-block

          & >>> div.calendarPicker
            white-space normal
            display block

      .btnGroup
        /*border 1px solid #00f*/
        text-align right
        padding-right 20px

        .desc
          display inline-block
          text-align left
          float left
          font-size 14px
          color #666666
          line-height 26px

        button
          width 90px
          height 26px
          text-align center
          color #ffffff
          font-size 12px
          background-color #548edf
          outline none
          border none
          border-radius 5px
          transition 300ms

          &:hover
            background-color #0077ee

    .overvie
      margin 15px

      .filterArea
        width 100%
        float right

        &::after
          content ''
          display block
          width 100%
          clear both
          margin-bottom 10px

        .desc
          display inline-block
          font-size 14px
          color #666666
          margin-left 10px

        .resetBtn
          display inline-block
          vertical-align middle
          width 50px
          height 24px
          line-height 24px
          outline none
          border 1px solid #cccccc
          border-radius 5px
          background-color #ffffff
          font-size 14px
          color #666666
          margin-left 10px
          transition 300ms

          &:hover
            background-color #eeeeee

        & >>> .multiselect
          width 220px
          border-radius 5px !important

        .filterSysName
          width 200px
          height 25px
          line-height 24px
          border-radius 13px
          padding-left 13px
          font-size 14px
          color #666666

        .searchContainer
          display inline-block
          border 1px solid #cccccc
          background-color #cccccc
          border-radius 14px
          width 200px
          position relative
          overflow hidden
          vertical-align middle

          input
            width 100%

          button
            position absolute
            right 0
            top 0
            display inline-block
            background-color #cccccc
            width 60px
            height 100%
            border none
            border-radius 13px
            outline none
            color #ffffff

            i
              font-size 20px


    .todolist
      padding 0 15px
      /*border 1px solid #00f*/

      table
        margin 20px
</style>



// WEBPACK FOOTER //
// src/components/todo/todoModal.vue